import {useCompetitionImamrezaContext} from '@context/CompetitionImamrezaContext';
import {useScopedTranslation} from '@hooks/useScopedTranslation';
import {Box, Button, ButtonProps, styled} from '@mui/material';
import React from 'react';
import ar from './assets/images/m0/ar.webp';

import bg from './assets/images/m0/bg.webp';
import boy from './assets/images/m0/boy.webp';
import en from './assets/images/m0/en.webp';
import fa from './assets/images/m0/fa.webp';
import title_ar from './assets/images/m0/title-ar.webp';
import title_en from './assets/images/m0/title-en.webp';
import title_fa from './assets/images/m0/title-fa.webp';

// Supported languages
const supportedLangs = ['en', 'fa', 'ar'] as const;
type Lang = typeof supportedLangs[number];

// Images for each language
const langImage: Record<Lang, string> = {en, fa, ar};
const titleImage: Record<Lang, string> = {en: title_en, fa: title_fa, ar: title_ar};

// Custom styled button
const ColorButton = styled(Button)<ButtonProps>(({theme}) => ({
	color: theme.palette.getContrastText('rgb(146, 64, 14)'),
	backgroundColor: 'rgb(146, 64, 14)',
	'&:hover': {
		backgroundColor: 'rgb(146, 64, 14)'
	}
}));

interface ResultEmptyProps {
	lang?: string;
}

export const ResultEmpty = ({lang}: ResultEmptyProps) => {
	const {t, i18n} = useScopedTranslation();
	const {phone, setPhone, mission, setMission, lang: defLang = 'fa'} = useCompetitionImamrezaContext();
	lang = lang ? lang : defLang;
	return (
		<Box
			className="flex flex-row w-full h-screen justify-start"
			sx={{
				backgroundImage: `url(${bg})`,
				backgroundRepeat: 'no-repeat',
				backgroundSize: 'cover'
			}}
		>
			<div className="w-10/12 mx-auto relative flex flex-col">
				{lang && (
					<div className="w-full my-10">
						<img src={titleImage[lang as Lang]} alt="title" className="w-full object-contain"/>
					</div>
				)}
				
				<div className="w-full flex justify-center mt-auto absolute bottom-0 left-0">
					<img
						src={boy}
						alt="boy"
						className="w-auto h-[calc(100vh-300px)] object-contain"
					/>
				</div>
			</div>
		</Box>
	);
};
